import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { TyreDiscountsDashboardQueryKeys } from "modules/TyreDiscountsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreBrandDiscount } from "models";

export const useAddTyreBrandDiscountMutation = () =>
  useTypedMutation<TyreBrandDiscount, number>({
    mutationFn: async (payload: TyreBrandDiscount) => (await ApiInstance.post("/tyre_discounts/add_brand", payload, ENV.dealerBaseURL)).data.tyre_brand_discount_id,
    onSuccess: (payload, tyre_brand_discount_id) => {
      const discounts = typedQueryClient.getQueryData(TyreDiscountsDashboardQueryKeys.discounts);
      if (!discounts) return;

      const discountIdx = discounts.findIndex(discount => discount.id === payload.tyre_discount_id);
      if (discountIdx === -1) return;

      typedQueryClient.setQueryData(
        TyreDiscountsDashboardQueryKeys.discounts,
        discounts.with(discountIdx, {
          ...discounts[discountIdx],
          tyre_brand_discounts: [...(discounts[discountIdx].tyre_brand_discounts || []), { ...payload, id: tyre_brand_discount_id }]
        })
      );
    }
  });
